import { objectToSnakeCase, objectToCamelCase } from '../utils'

import GoalAPI from './api'

export default class Goal {
  static api = GoalAPI.create(Goal)

  constructor({
    id = null,
    title = '',
    description = '',
    project = '',
    targetFunds = 0,
    receivedFunds = 0,
    uncollectedFunds = 0,
    collectedFunds = 0,
    transferringFunds = 0,
    startDate = null,
    endDate = null,
  } = {}) {
    Object.assign(this, {
      id,
      title,
      description,
      project,
      targetFunds,
      receivedFunds,
      uncollectedFunds,
      collectedFunds,
      transferringFunds,
      startDate,
      endDate,
    })
  }

  copy() {
    return new Goal(this)
  }

  update(data = {}) {
    return Object.assign(this.copy(), data)
  }

  static create(data = {}) {
    return new Goal(data)
  }

  static fromAPI(json = {}) {
    return new Goal(objectToCamelCase(json))
  }

  /* Prep data for the API. Can elect to include */
  static toAPI(goal, fields = []) {
    let data = {}
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = goal[field]
      })
    } else {
      data = goal
    }

    return objectToSnakeCase(data)
  }

  static checkIsInstance(obj, name) {
    if (!(obj instanceof Goal)) {
      throw Error(`${name} must be an instance of the Goal class.`)
    }
  }
}
